import {  useMemo } from 'react';
import SelectInput from './SelectInput';
import useDepartmentData from '../../hooks/useDepartmentData';

const DepartmentSelectInput = ({
  register,
  errors,
  name,
  validationRules = { required: 'Department is required' },
  className = '',
  withOtherOption = false,
  facultyId = null,
  showLabel = true,
  placeHolder = null,
  fullWidth = true,
  disablePlaceholderOption = true,
}) => {
  let {departments, loading} = useDepartmentData()

  
  let filteredDepartment = facultyId ? 
    departments.filter(dep => dep.faculty === facultyId || dep.faculty?.id === facultyId) : departments; 
  
  const departmentOptions = [
    ...filteredDepartment.map(({ id, name }) => ({ value: id, label: name })),
    ...(withOtherOption ? [{ value: 'other', label: 'Other' }] : [])
  ];


  if (loading) {
    return <p>Loading department...</p>;
  }

  return (
    <SelectInput
      label="Department"
      name={name}
      register={register}
      errors={errors}
      options={departmentOptions}
      validationRules={validationRules}
      showLabel={showLabel}
      placeHolder={placeHolder}
      fullWidth={fullWidth}
      className={className}
      disablePlaceholderOption={disablePlaceholderOption}
    />
  );
};

export default DepartmentSelectInput;
